import React, { useContext, useEffect, useState } from "react";
import {
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { get } from "lodash";
import { MediaRequestContext } from "../../context/MediaRequestContext";
import MediaRequestEpisodeAccordions from "./MediaRequestEpisodeAccordions";
import { ASSET_TYPE, PAGE_ERROR } from "../../constants/MediaSearch";
import { PageErrorContent } from "../page-error/PageError";
import { ReactComponent as Info } from "../../assets/icons/information.svg";
import "./table.scss";

const MediaRequestSeasonTable = () => {
  const {
    seasonData,
    seasonDataError,
    isSeasonDataLoading,
    selectedOption,
    fetchAssets,
    callSearchById,
    episodeData,
    episodeDataError,
    isEpisodeDataLoading,
    recordType,
  } = useContext(MediaRequestContext);
  const [showEpisodes, setShowEpisodes] = useState([]);

  const selectedOptionLabel = get(selectedOption, "payload.title", "");

  useEffect(() => {
    setShowEpisodes([]);
  }, [seasonData]);

  useEffect(() => {
    const selectedSeasons = [...showEpisodes];
    if (recordType === ASSET_TYPE.SERIES && seasonData) {
      for (const season of seasonData) {
        if (episodeData[season.relatedEntityId.id]) {
          selectedSeasons.push(season.relatedEntityId.id);
        }
      }
    }
    setShowEpisodes(selectedSeasons);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFetchEpisodes = (guid) => {
    if (!episodeData[guid]) {
      callSearchById(guid);
    }
  };

  const errorPage = (callback) => (
    <div className="media-search-table-header media-error-container">
      <PageErrorContent
        title={PAGE_ERROR.title}
        message={PAGE_ERROR.message}
        reloadBtn={true}
        onReloadClick={callback}
      />
    </div>
  );

  const noResultsMessage = (message) => (
    <p className="media-no-result-paragraph">
      <Info className="media-info-icon" /> {message}.
    </p>
  );

  const MediaAssetWrapper = ({ children }) => (
    <div className="media-asset pt-1">{children}</div>
  );

  const getSeasonTitle = (asset) => {
    return get(asset, "relatedEntityDisplayTitle", "NA");
  };

  const findEpisodes = (id) => showEpisodes.includes(id);

  const handleShowEpisodes = (id) => {
    if (!findEpisodes(id)) {
      setShowEpisodes([...showEpisodes, id]);
    } else {
      const hideEpisodes = showEpisodes.filter((item) => item !== id);
      setShowEpisodes(hideEpisodes);
    }
  };

  return (
    <div className="seasons-result">
      {isSeasonDataLoading && !seasonData?.length && !seasonDataError && (
        <div className="season-data-wrapper">
          <CircularProgress size={35} />
        </div>
      )}
      {!isSeasonDataLoading && !seasonData?.length && seasonDataError && (
        <div className="season-data-wrapper">
          {errorPage(() => fetchAssets(selectedOption))}
        </div>
      )}
      {!isSeasonDataLoading && !seasonData?.length && !seasonDataError ? (
        <div className="season-data-wrapper">
          {noResultsMessage(
            `No result found for the selected series: ${selectedOptionLabel}`
          )}
        </div>
      ) : null}
      {!isSeasonDataLoading && seasonData && !seasonDataError
        ? seasonData.map((season, index) => (
            <Accordion
              classes={{
                expanded: "media-accordion",
              }}
              className="media-assets-accordion"
              key={`accordion-${index}`}
              expanded={findEpisodes(season.relatedEntityId.id)}
              onChange={() => {
                handleShowEpisodes(season.relatedEntityId.id);
                handleFetchEpisodes(season.relatedEntityId.id);
              }}
            >
              <AccordionSummary expandIcon={<ExpandMore />}>
                {getSeasonTitle(season)}
              </AccordionSummary>
              <AccordionDetails className="justify-center">
                <Table>
                  <TableHead className="media-search-table-header">
                    <TableRow>
                      <TableCell className="media-cell">Episodes</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <div className="episodes-result">
                      {isEpisodeDataLoading[season.relatedEntityId.id] &&
                        !episodeData[season.relatedEntityId.id] &&
                        !episodeDataError[season.relatedEntityId.id] && (
                          <MediaAssetWrapper>
                            <CircularProgress size={35} />
                          </MediaAssetWrapper>
                        )}
                      {!isEpisodeDataLoading[season.relatedEntityId.id] &&
                        !episodeData[season.relatedEntityId.id] &&
                        episodeDataError[season.relatedEntityId.id] && (
                          <MediaAssetWrapper>
                            {" "}
                            {errorPage(() =>
                              callSearchById(season.relatedEntityId.id)
                            )}{" "}
                          </MediaAssetWrapper>
                        )}

                      {!isEpisodeDataLoading[season.relatedEntityId.id] &&
                      episodeData[season.relatedEntityId.id] &&
                      !episodeData[season.relatedEntityId.id].length &&
                      !episodeDataError[season.relatedEntityId.id] ? (
                        <MediaAssetWrapper>
                          {noResultsMessage(
                            `No result found for the selected season: ${season.relatedEntityDisplayTitle}`
                          )}
                        </MediaAssetWrapper>
                      ) : null}
                      {!isEpisodeDataLoading[season.relatedEntityId.id] &&
                      episodeData[season.relatedEntityId.id]?.length &&
                      !episodeDataError[season.relatedEntityId.id]
                        ? episodeData[season.relatedEntityId.id].map(
                            ({ asset }, index) => (
                              <MediaRequestEpisodeAccordions
                                key={`episode-${index}`}
                                asset={asset}
                                assetIndex={index}
                              />
                            )
                          )
                        : null}
                    </div>
                  </TableBody>
                </Table>
              </AccordionDetails>
            </Accordion>
          ))
        : null}
    </div>
  );
};

export default MediaRequestSeasonTable;
